module.exports = __webpack_public_path__ + "img/card-frame-purple.c48f0157.png";